import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import Button from './Button';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details
    console.error('Error caught by boundary:', error, errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // You can also log the error to an error reporting service here
    // logErrorToService(error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      // Custom error UI
      return (
        <div className="error-boundary">
          <div className="error-container">
            <div className="error-icon">
              <AlertTriangle size={64} />
            </div>
            
            <div className="error-content">
              <h1>¡Oops! Algo salió mal</h1>
              <p className="error-message">
                Ha ocurrido un error inesperado. Por favor, intenta recargar la página 
                o regresa al inicio.
              </p>
              
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <details className="error-details">
                  <summary>Detalles técnicos (solo en desarrollo)</summary>
                  <div className="error-stack">
                    <h4>Error:</h4>
                    <pre>{this.state.error.toString()}</pre>
                    
                    <h4>Stack Trace:</h4>
                    <pre>{this.state.errorInfo.componentStack}</pre>
                  </div>
                </details>
              )}
              
              <div className="error-actions">
                <Button 
                  variant="primary" 
                  onClick={this.handleReload}
                  icon={RefreshCw}
                >
                  Recargar página
                </Button>
                
                <Button 
                  variant="outline" 
                  onClick={this.handleGoHome}
                  icon={Home}
                >
                  Ir al inicio
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;